import { FormDataEntryObj } from '@utils/types';
import { VisibleMetadataByName } from './types';

export const correctFormDataObjBeforeRequest = (
    formDataEntryObj: FormDataEntryObj,
    visibleMetadataByName: VisibleMetadataByName
) => {
    return Object.entries(formDataEntryObj).reduce((acc, [fieldName, value]) => {
        const { type } = visibleMetadataByName[fieldName];
        if ((type === 'Integer' || type === 'Double') && formDataEntryObj[fieldName] === '') {
            acc[fieldName] = null;
        } else {
            acc[fieldName] = formDataEntryObj[fieldName];
        }
        return acc;
    }, {});
};
